import type { DependencyContainer } from 'tsyringe';
import type { DpProvider } from '@/core/di/DpProvider';
import { MessageTemplateRepositoryToken } from '@/modules/settings/di/token';
import { HttpMessageTemplateRepository } from '@/modules/settings/adapters/message-templates/HttpMessageTemplateRepository';

export class MessageTemplatesProvider implements DpProvider {
  register(container: DependencyContainer): void {
    container.register(MessageTemplateRepositoryToken, HttpMessageTemplateRepository);
  }
}
